import React, {Component} from "react";
import {mesAutobind} from "@posco/posco-shared";
import {inject, observer} from "mobx-react";
import O10g014111View from "../view/O10g014111View";

/*다국어 적용을 위한 whitTranslation import*/
import {withTranslation} from "react-i18next";
import {Common} from "@plm/o10-share-front";
import O10g014112Container from "../../o10g014112/container/O10g014112Container";

@inject("o10g014111Stores")
@mesAutobind
@observer
class O10g014111Container extends Component {


  /*props로부터 다국어 표현을 위한 t함수 획득*/
  get translate() {
    const {t} = this.props;
    //console.log(t)
    return ({
      O10_LH_00018: t("O10_LH_00018", {ns: "common"}),//전체
      O10_LH_00019: t("O10_LH_00019", {ns: "common"}),//건
      O10_MW_00009: t("O10_MW_00009", {ns: "common", 0: t("O10G014110_LH_00002", {ns: "service"})})//"{{0}}을(를) 필수로 선택하시기 바랍니다."
    });
  }

  componentDidMount() {
    this.props.o10g014111Stores.invbpInfoFind();
    this.props.o10g014111Stores.userInfoFind();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.props.o10g014111Stores.invpInfo && this.props.o10g014111Stores.invpInfo.A) {
      if (this.props.o10g014111Stores.invpInfo.A.cnt) {
        this.props.getProfileNoti(Number(this.props.o10g014111Stores.invpInfo.A.cnt) || 0);
      }
    }
  }


  async onUserInfoFind() {
    const result = await this.props.o10g014111Stores.userInfoFind();
    return result;
  }

  async onInvbpInfoFindDetail(type) {
    const result = await this.props.o10g014111Stores.invbpInfoFindDetail(type);
    return result;
  }


  render() {
    return (
      <>
        {Common.PotalUtil.getStorageItem("Posco.auth.userInfo").isPoscoUser === "Y" ?
          //포스코 유저면 프로필 화면
          <O10g014111View
            translate={this.translate}
            invpInfo={this.props.o10g014111Stores.invpInfo}
            invpInfoDetail={this.props.o10g014111Stores.invpInfoDetail}
            userInfo={this.props.o10g014111Stores.userInfo}
            onUserInfoFind={this.onUserInfoFind}
            onInvbpInfoFindDetail={this.onInvbpInfoFindDetail}
          />
          :
          //포스코 유저가 아니면 사용자 정보변경
          <O10g014112Container
            open={this.props.open}
            openToggle={this.props.openToggle}
            userInfo={this.props.o10g014111Stores.userInfo}
            onUserInfoFind={this.onUserInfoFind}
          />
        }
      </>

    );
  }
}

export default withTranslation()(O10g014111Container);
